// The Sort dropdown above the search bar on Collings Properties and My Listings.
//
// Christian Gravias, 7 Oct 2026 (Monday 13122905047): "Can we please also add a
// sort button on top of settings & search for both my listings & collings
// properties" - Date (Newest - Oldest), Date (Oldest - Newest),
// Price (Lowest - Highest), Price (Highest - Lowest).
//
// Both pages load page by page, so the order is the backend's: the id here is
// sent as `?sort=` (PropertyListingView.SORT_ORDERS). Listings with no price
// ("Contact Agent", "Auction") go to the bottom of either price order.
export const LIST_SORT_OPTIONS = [
    { id: "date_desc", label: "Date (Newest - Oldest)", group: "date" },
    { id: "date_asc", label: "Date (Oldest - Newest)", group: "date" },
    { id: "price_asc", label: "Price (Lowest - Highest)", group: "price" },
    { id: "price_desc", label: "Price (Highest - Lowest)", group: "price" },
];

// Newest first is what the list has always opened on.
export const DEFAULT_LIST_SORT = "date_desc";

// The query param for a pick, or nothing for the default so the request (and
// its cache key) stays exactly as it was before the dropdown existed.
export const listSortParam = (sort) =>
    sort && sort !== DEFAULT_LIST_SORT && LIST_SORT_OPTIONS.some((o) => o.id === sort)
        ? { sort }
        : {};
